(() => {
  const root = document.body.dataset.root || '/';
  const messages = JSON.parse(document.getElementById('theme-messages')?.textContent || '{}');
  const money = value => new Intl.NumberFormat(document.body.dataset.locale || 'en-AU', {style:'currency',currency:document.body.dataset.currency || 'AUD'}).format(value / 100);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cartDialog = document.getElementById('cart-drawer');
  const quickDialog = document.getElementById('quick-dialog');
  let busy = false;
  const status = text => { document.querySelector('[data-global-status]').textContent = text; };
  function openDialog(dialog) {
    document.querySelectorAll('dialog[open]').forEach(el => el.close());
    dialog.showModal();
    document.documentElement.classList.add('dialog-open');
  }
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => document.documentElement.classList.toggle('dialog-open', !!document.querySelector('dialog[open]')));
    dialog.addEventListener('click', e => { if(e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close(); } });
  });
  function sectionUrl(path, section) {
    const url = new URL(path, location.origin);
    if(url.origin !== location.origin)throw new Error(messages.error);
    url.searchParams.set('section_id', section);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    return url;
  }
  async function request(url, options) {
    const response = await fetch(url, {credentials:'same-origin',...options});
    let data;
    try { data = await response.json(); } catch { throw new Error(messages.error); }
    if(!response.ok || data.status >= 400)throw new Error(data.description || data.message || messages.error);
    return data;
  }
  async function refreshCart(cart) {
    const note = document.querySelector('#cart-panel-content [name=note]')?.value;
    const response = await fetch(sectionUrl(root, 'cart-panel'), {credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error(messages.error);
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const panel = parsed.querySelector('.shopify-section');
    if(!panel)throw new Error(messages.error);
    document.getElementById('cart-panel-content').replaceChildren(...panel.childNodes);
    const noteInput = document.querySelector('#cart-panel-content [name=note]');
    if(noteInput && note !== undefined)noteInput.value = note;
    cart ||= await request(root + 'cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  }
  async function changeCart(key,quantity) {
    if(busy)return;
    busy=true;
    document.querySelectorAll('.cart-form button,.cart-form input').forEach(el=>el.disabled=true);
    try {
      const note = document.querySelector('.cart-form [name=note]')?.value;
      if(note !== undefined)await request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})});
      const cart=await request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      if(document.querySelector('.cart-page')){location.reload();return;}
      await refreshCart(cart);status('');
    } catch(error) {status(error.message || messages.error);if(!document.querySelector('.cart-page')){try{await refreshCart();}catch{}}}
    finally {busy=false;document.querySelectorAll('.cart-form button,.cart-form input').forEach(el=>el.disabled=false);}
  }
  function initProduct(scope=document) {
    scope.querySelectorAll('[data-product-form]').forEach(form => {
      if(form.dataset.ready)return;
      form.dataset.ready='true';
      const plans=JSON.parse(form.querySelector('[data-plans]').textContent);
      const selector=form.querySelector('[name=selling_plan]');
      function update(){
        const input=form.querySelector('[name=id]:checked');
        const variant=plans.variants.find(v=>String(v.id)===input?.value);
        if(selector){
          selector.disabled=!variant;
          Array.from(selector.options).forEach(option=>{
            if(!option.value)return;
            const valid=variant?.plans.some(p=>String(p.id)===option.value);
            option.disabled=!valid;option.hidden=!valid;
          });
          if(selector.selectedOptions[0]?.disabled)selector.value='';
        }
        const allocation=variant?.plans.find(p=>String(p.id)===selector?.value);
        const page=form.closest('[data-product-handle]');
        const price=variant ? money(allocation?.price ?? variant.price) : form.querySelector('[data-product-price]').textContent;
        form.querySelector('[data-product-price]').textContent=price;
        const stickyPrice=page?.querySelector('[data-sticky-price]');
        if(stickyPrice)stickyPrice.textContent=price;
        const unavailable=variant ? !variant.available : !plans.available;
        const button=form.querySelector('.add-button');
        if(!button.dataset.original)button.dataset.original=button.innerHTML;
        button.disabled=unavailable;
        if(unavailable)button.textContent=messages.sold;else button.innerHTML=button.dataset.original;
        const stickyButton=page?.querySelector('[data-sticky-add]');
        if(stickyButton){stickyButton.disabled=unavailable;stickyButton.textContent=unavailable?messages.sold:messages.add;}
        const description=form.querySelector('[data-plan-description]');
        if(description)description.textContent=allocation?.description || '';
        const terms=form.querySelector('[data-plan-terms]');
        if(terms){if(!terms.dataset.original)terms.dataset.original=terms.textContent;terms.textContent=allocation?.recurring?plans.recurringText:terms.dataset.original;}
        if(input?.dataset.image){
          const page=form.closest('[data-product-handle]');
          const images=Array.from(page.querySelectorAll('.gallery-image img'));
          const match=images.find(img=>new URL(img.src).pathname===new URL(input.dataset.image, location.origin).pathname);
          if(match){const track=page.querySelector('.gallery-track');track.scrollTo({left:match.closest('.gallery-image').offsetLeft-track.offsetLeft,behavior:reduced()?'instant':'smooth'});}
        }
      }
      form.addEventListener('change',update);update();
    });
    scope.querySelectorAll('[data-sticky-buy]').forEach(sticky => {
      if(sticky.dataset.ready || sticky.closest('dialog'))return;
      sticky.dataset.ready='true';
      const purchase=sticky.closest('[data-product-handle]').querySelector('.purchase');
      const observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;});
      observer.observe(purchase);
    });
  }
  document.addEventListener('submit', async e => {
    const form=e.target;
    if(!form.matches('[data-product-form]'))return;
    e.preventDefault();
    if(busy||!form.reportValidity())return;
    busy=true;
    const button=form.querySelector('.add-button');
    const label=button.innerHTML;
    const errorBox=form.querySelector('[data-form-error]');
    errorBox.hidden=true;
    const data=new FormData(form);
    button.disabled=true;button.textContent=messages.adding;
    try {
      await request(root+'cart/add.js',{method:'POST',body:data});
      try {await refreshCart();openDialog(cartDialog);}catch {location.assign(root+'cart');}
    } catch(error) {errorBox.textContent=error.message || messages.error;errorBox.hidden=false;}
    finally {busy=false;button.disabled=false;button.innerHTML=label;}
  });
  document.addEventListener('click', async e => {
    const close=e.target.closest('[data-close]');
    if(close){close.closest('dialog').close();return;}
    const cart=e.target.closest('[data-cart-open]');
    if(cart){e.preventDefault();try{await refreshCart();openDialog(cartDialog);}catch{location.assign(cart.href);}return;}
    const remove=e.target.closest('[data-cart-remove]');
    if(remove){e.preventDefault();await changeCart(remove.dataset.cartRemove,0);return;}
    const quick=e.target.closest('[data-quick-url]');
    if(quick){
      e.preventDefault();
      const content=quickDialog.querySelector('[data-quick-content]');
      content.textContent=messages.loading;openDialog(quickDialog);
      try{
        const response=await fetch(sectionUrl(quick.href,'main-product'),{credentials:'same-origin'});
        if(!response.ok)throw new Error(messages.error);
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const page=doc.querySelector('[data-product-handle]');
        if(!page)throw new Error(messages.error);
        page.querySelectorAll('.sticky-buy,.breadcrumbs,.product-details').forEach(el=>el.remove());
        content.replaceChildren(page);initProduct(content);
      }catch{quickDialog.close();location.assign(quick.href);}return;
    }
    const pause=e.target.closest('[data-marquee-pause]');
    if(pause){const bar=pause.closest('.announcement');const paused=bar.classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?messages.play:messages.pause);pause.firstElementChild.textContent=paused?'▶':'Ⅱ';return;}
    const slide=e.target.closest('[data-slide]');
    if(slide){const track=slide.closest('.product-gallery').querySelector('.gallery-track');track.scrollTo({left:track.clientWidth*Number(slide.dataset.slide),behavior:reduced()?'instant':'smooth'});return;}
    const sticky=e.target.closest('[data-sticky-add]');
    if(sticky){const form=sticky.closest('[data-product-handle]').querySelector('form');if(form.checkValidity())form.requestSubmit();else{form.scrollIntoView({block:'center',behavior:reduced()?'instant':'smooth'});form.reportValidity();}return;}
    const zoom=e.target.closest('[data-zoom]');
    if(zoom){e.preventDefault();let dialog=document.getElementById('zoom-dialog');if(!dialog){dialog=document.createElement('dialog');dialog.id='zoom-dialog';dialog.className='native-dialog zoom-dialog';const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label',document.querySelector('[data-close]').getAttribute('aria-label'));close.addEventListener('click',()=>dialog.close());const img=document.createElement('img');dialog.append(close,img);document.body.append(dialog);}const img=dialog.querySelector('img');img.src=zoom.href;img.alt=zoom.querySelector('img')?.alt||'';dialog.showModal();}
  });
  document.addEventListener('change', e => {
    const input=e.target.closest('[data-cart-change]');
    if(input){const quantity=Number(input.value);if(Number.isInteger(quantity)&&quantity>=0&&quantity<=20)void changeCart(input.dataset.cartChange,quantity);else input.reportValidity();}
  });
  function initSearch(scope=document){scope.querySelectorAll('[data-predictive]').forEach(form=>{
    if(form.dataset.ready)return;form.dataset.ready='true';
    let timer,controller;
    const input=form.querySelector('[name=q]');
    const results=form.querySelector('.search-results');
    input.addEventListener('input',()=>{
      clearTimeout(timer);controller?.abort();
      if(input.value.trim().length<2){results.replaceChildren();return;}
      timer=setTimeout(async()=>{
        controller=new AbortController();
        const url=sectionUrl(root+'search/suggest','predictive-search');
        url.searchParams.set('q',input.value);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','6');
        try{const response=await fetch(url,{signal:controller.signal});if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const section=doc.querySelector('.shopify-section');if(section)results.replaceChildren(...section.childNodes);}catch{}
      },250);
    });
    input.addEventListener('keydown',e=>{if(e.key==='Escape')results.replaceChildren();if(e.key==='ArrowDown'){e.preventDefault();results.querySelector('a')?.focus();}});
  });}
  async function recent(){
    const section=document.querySelector('[data-recent-section]');
    const current=document.querySelector('main [data-product-handle]')?.dataset.productHandle;
    try{
      const stored=JSON.parse(localStorage.getItem('angus_recent')||'[]');
      const handles=(Array.isArray(stored)?stored:[]).filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h));
      if(current)localStorage.setItem('angus_recent',JSON.stringify([current,...handles.filter(h=>h!==current)].slice(0,8)));
      if(!section)return;
      const grid=section.querySelector('[data-recent-grid]');
      const available=handles.filter(h=>h!==current).slice(0,4);
      for(const handle of available){
        const response=await fetch(sectionUrl(root+'products/'+handle,'product-card-only'));
        if(!response.ok)continue;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const card=doc.querySelector('.product-card');if(card)grid.append(card);
      }
      section.hidden=!grid.children.length;
    }catch{}
  }
  document.querySelectorAll('[data-address-country]').forEach(select=>{
    if(Array.from(select.options).some(option=>option.value===select.dataset.addressCountry))select.value=select.dataset.addressCountry;
  });
  initProduct();initSearch();void recent();
  document.addEventListener('shopify:section:load',e=>{initProduct(e.target);initSearch(e.target);});
})();
